export default __webpack_public_path__ + "static/media/bathroom1-before-768w.56160afc.png";